import { ServiceResponse } from '@sdbn/appclient';
import { Injectable } from '@angular/core';
import { HttpService } from '@sdbn/appclient';
import { Observable } from 'rxjs';
import { TransportRegistration } from '../model/transport-registration';
import { environment } from 'src/environments/environment';
import { TransportRegistrationIdentity } from '../model/out/transport-registration-identity';
import { TrransportRegistrationServiceResponse } from '../model/trransport-registration-service-response';
import { Route } from '../model/route';
import { RegistrationTransportOption } from '../model/registration-transport-option';
import { TransportRouteSelection } from '../model/out/transport-route-selection';

@Injectable({
  providedIn: 'root'
})
export class TransportRegistrationService {

  constructor(private http: HttpService) { }

  getNewRegistration(identity: TransportRegistrationIdentity): Observable<TransportRegistration> {
    return this.http.postWithContext(`${environment.transportRegistrationEndpoint}/new`, identity);
  }

  save(transportRegistration: TransportRegistration): Observable<TrransportRegistrationServiceResponse> {
    return this.http.postWithContext(`${environment.transportRegistrationEndpoint}/save`, transportRegistration);
  }

  findCarriersStartingByName(name: string): Observable<string[]> {
    return this.http.postWithContext(`${environment.transportRegistrationEndpoint}/carriers-by-name`, name);
  }

  findString1StartingWith(name: string): Observable<string[]> {
    return this.http.postWithContext(`${environment.transportRegistrationEndpoint}/string1`, name);
  }

  findNumberPlatesStartingWith(name: string): Observable<string[]> {
    return this.http.postWithContext(`${environment.transportRegistrationEndpoint}/numberplates`, name);
  }

  getPositionsforTransportOptions(selection: TransportRouteSelection): Observable<Route> {
    return this.http.postWithContext(`${environment.transportRegistrationEndpoint}/option-positions`, selection);
  }

  validateMasterdata(transportRegistration: TransportRegistration): Observable<ServiceResponse> {
    return this.http.postWithContext(`${environment.transportRegistrationEndpoint}/validate-masterdata`, transportRegistration);
  }
}
